var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1094 4.20737C10.5469 4.5441 10.6299 5.17197 10.293 5.60971L5.29297 12.1097C5.11719 12.3378 4.85156 12.4792 4.56445 12.4979C4.27734 12.5165 3.99609 12.4106 3.79297 12.2071L0.292969 8.70709C-0.0976562 8.31656 -0.0976562 7.68344 0.292969 7.29291C0.683594 6.90237 1.31641 6.90237 1.70703 7.29291L4.40137 9.98758L8.70703 4.39029C9.04395 3.95255 9.67188 3.87064 10.1094 4.20737Z",
    fill: "#797979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13309 -272C-13309 -272.552 -13308.6 -273 -13308 -273H-13208C-13207.4 -273 -13207 -272.552 -13207 -272V-172C-13207 -171.448 -13207.4 -171 -13208 -171H-13308C-13308.6 -171 -13309 -171.448 -13309 -172V-272ZM-13307 -271V-173H-13209V-271H-13307ZM15.1094 4.20737C15.5479 4.5441 15.6289 5.17197 15.293 5.60971L10.293 12.1097C10.1172 12.3378 9.85156 12.4792 9.56445 12.4979C9.27734 12.5165 8.99609 12.4106 8.79297 12.2071L6.0625 9.4765C5.67188 9.08597 5.67188 8.45279 6.0625 8.06229C6.45312 7.67178 7.08594 7.67178 7.47656 8.06232L9.40137 9.9874L13.707 4.39029C14.0439 3.95255 14.6719 3.87064 15.1094 4.20737ZM13322.5 283.319C13322.8 283.104 13323.2 283 13323.5 283C13323.8 283 13324.2 283.104 13324.5 283.319C13324.7 283.535 13325 283.903 13325 284.384V287.176C13325 287.658 13324.7 288.025 13324.5 288.241C13324.2 288.456 13323.8 288.56 13323.5 288.56C13323.2 288.56 13322.8 288.456 13322.5 288.241C13322.3 288.025 13322 287.658 13322 287.176V284.384C13322 283.903 13322.3 283.535 13322.5 283.319Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/DoubleCheck.d5445f75b1cbb76d354458efd81d35ac.svg";
export { ForwardRef as ReactComponent };